import { EntryProps, getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

export const ConversationCreated = ({ entry }: EntryProps): JSX.Element => {
  const entityType =
    entry.activity_type === 'CONVERSATION_CREATED_BY_AGENT'
      ? 'agent'
      : 'customer';

  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const text = (
    <>
      Conversation is created by {entityType} {authorLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
